import { useCallback, useEffect } from 'react';

/**
 * @description [iOS 전용] 앱에서 현재 표시된 웹뷰에서 요소를 찾아 포커스를 주는 훅
 * - 안드로이드 웹뷰에선 포커스를 웹에서 제어할 수 있지만 iOS에선 불가능하여 앱에서 제어해야 함
 */
export const useFocusElementByApp = () => {
  const handleFocusElement = useCallback(
    ({ id, options = { preventScroll: true } }: { id: string; options?: { preventScroll?: boolean } }) => {
      if (!window?.webkit) {
        return;
      }

      const params = JSON.stringify({ id, options });
      window.webkit.messageHandlers.focusElement.postMessage(params);
    },
    []
  );

  useEffect(() => {
    // 사용하지 않는 이벤트 핸들러, 콘솔에 에러 메시지 발생 방지
    window.onFocusElement = () => {};

    return () => {
      window.onFocusElement = null;
    };
  }, []);

  return { handleFocusElement };
};
